function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Utils from './utils';
import compact from 'lodash/compact';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import escape from 'lodash/escape';
var defaultElementsConfig = {
  minimum: 1,
  maximum: 5,
  types: ['units', 'tokens'],
  distances: true,
  defaultType: 'units',
  defaultDistance: null,
  tokens: {
    fields: {
      token: null,
      tag: 'NcsTagSelector',
      lemma: null,
      unit: 'NcsTokenUnitField'
    }
  }
};
var frequency = {
  endpoint: 'frequency',
  defaultDisplay: 'frequency',
  order: false,
  pagination: false,
  elements: _objectSpread({}, defaultElementsConfig)
};
var full_frequency = {
  endpoint: 'full_frequency',
  groups: {// Example:
    // group: { filters: [], getValues: v => v.split('-'), sortBy: v => v.split('-') }
  },
  frequency_group_order: null,
  defaultDisplay: 'full_frequency',
  order: false,
  pagination: false,
  elements: _objectSpread({}, defaultElementsConfig)
};
var kwic = {
  endpoint: 'kwic',
  separator: false,
  maxHeaderSize: 50,
  // Percentage of result table width
  contextOnRowClick: false,
  defaultDisplay: 'kwic',
  order: {
    orders: Utils.defaultOrder(),
    "default": ['matching']
  },
  pagination: true,
  elements: _objectSpread({}, defaultElementsConfig)
};
var context = {
  endpoint: 'context',
  documentHeader: true,
  textHeader: false,
  units: {
    sourceText: false
  },
  tokens: {
    sourceText: false
  },
  separator: false,
  defaultDisplay: 'context',
  order: false,
  pagination: false,
  elements: {}
};
var matching_expressions = {
  endpoint: 'matching_expressions',
  maxHeaderSize: 50,
  defaultDisplay: 'matching_expressions',
  order: {
    orders: [{
      name: 'matching',
      criteria: Utils.matchingOrder(5, true)
    }, {
      name: 'elements',
      criteria: [{
        field: 'matching_expressions.elements',
        asc: false
      }]
    }],
    "default": ['elements', 'matching']
  },
  frequencyGroupOrder: null,
  pagination: true,
  grouping: true,
  elements: _objectSpread({}, defaultElementsConfig),
  units: {
    groups: ['unit'],
    defaultGroups: ['unit']
  },
  tokens: {
    groups: ['token', 'tag', 'lemma', 'unit'],
    defaultGroups: ['token']
  },
  group_values: {// Required to format rows
  },
  default_frequency_groups: [],
  groups: {// Example:
    // group: { filters: [], getValues: v => v.split('-'), sortBy: v => v.split('-') }
  }
}; // Collocations is like matching expressions but:
// - Different input method.
// - No distances.

var collocations = _objectSpread(_objectSpread({}, matching_expressions), {}, {
  elements: _objectSpread(_objectSpread({}, defaultElementsConfig), {}, {
    distances: false
  })
});

export default {
  i18n: {
    locale: null,
    translations: {},
    raeNumberFormat: true
  },
  analytics: {
    trackerId: null
  },
  infoIconClass: 'fa fa-question-circle',
  // Custom format functions
  // Will be available in the component instance as $ncs<function> in camel case.
  // "this" used in the function refers to the component instance.
  format: {
    // Returns the title that should be displayed for an element
    elementTitle: function elementTitle(element) {
      var _this = this;

      var tag = element.tag ? this.$tTag(element.tag) : null;
      var info = element.info ? element.info.map(function (i) {
        return _this.$tOr('info', i);
      }) : [];
      return compact([tag, element.lemma].concat(_toConsumableArray(info))).join(' - ');
    },
    // Returns the class for an element
    elementClass: function elementClass(element, isMatch) {
      var _this2 = this;

      var result = isMatch && isMatch(element) ? ['match'] : [];

      if (element.info) {
        var infos = element.info.map(function (i) {
          return _this2.$tOr('info', i).replace(' ', '-');
        });
        result = [].concat(_toConsumableArray(result), ['info'], _toConsumableArray(infos));
      }

      return result.join(' ');
    },
    // Returns the visible form of an element and inserts a space after it unless
    // the next element should appear joined. Useful for kwic and context.
    elementContent: function elementContent(element, useSeparator) {
      // If useSeparator is true, a space will be inserted always.
      // Otherwise it depends on the element property, true if undefined.
      var separator = useSeparator || isUndefined(element.separator) || isNull(element.separator) || element.separator;
      var value = element.visible || element.token || element.unit || '';
      return "".concat(escape(value)).concat(separator ? ' ' : '');
    }
  },
  // Categories are an optional way to group elements by groups of tags in matching expressions.
  // In general the first tag level is the category, but any tag pattern can be used.
  categories: {
    patterns: {}
  },
  tags: {
    categories: [],
    matrix: [],
    // The following levels won't be shown in the friendly selector.
    // Their value will be always empty, as if they didn't exists.
    hideLevels: [],
    sortBy: function sortBy(o) {
      return o.label;
    } // By default, friendly selector options are sort by label.

  },
  filters: {
    // List of values per each filter
    values: {},
    // {Filter id => function}
    // All the combinations of filters and values that have any dependent or dependency filter
    dependency_values: [],
    sortBy: {}
  },
  elements: {
    // List of supported elements in the system.
    // Only these ones will be used regardless of result type configuration.
    types: ['units'],
    emptyElement: function emptyElement() {
      return {
        token: {
          value: null
        },
        tag: {
          value: []
        },
        lemma: {
          value: null
        },
        unit: {
          value: null
        }
      };
    }
  },
  result: {
    apiPath: '/api',
    retryTimeouts: [0, 100, 500, 500, 3000, 5000],
    // Types that can be selected in the form
    types: ['frequency', 'full_frequency', 'kwic', 'matching_expressions', 'collocations'],
    // Types that are accessed through result links (or other means). They cannot be selected directly.
    detailTypes: ['context'],
    defaultType: 'kwic',
    error: {
      contactLink: '#',
      contactEmail: 'admin@nlpgo.com'
    },
    frequency: frequency,
    full_frequency: full_frequency,
    context: context,
    kwic: kwic,
    matching_expressions: matching_expressions,
    collocations: collocations
  },
  download: {
    kwic: {
      header: true,
      delimiter: '\t',
      filename: 'results.csv'
    }
  },
  pagination: {
    pageSizes: [50, 100, 500],
    defaultPageSize: 50,
    pagesStartEnd: 1,
    pagesAround: 1
  },
  queryLinks: {
    enabled: false,
    parseQuery: Utils.parseQuery,
    stringifyQuery: Utils.stringifyQuery
  }
};